'use strict';
import answers from './answer-store';
import {
  buildInitialAnswers,
  strayKeys,
  unseededVariables,
} from './answer-seed';

global.page_state = {};

// The AnswerStore does NOT write through to `page_state.form_data`.
//
// It did, briefly. `page_state.form_data` is the server's load-time snapshot and
// the Handlebars `answer`/`ans`/`ifanswerexists` helpers read it, so making it
// mutate during a page changed what later markup renders: any widget rendered
// after a store write (dyngrid phases, multiple-colorpicker phases, popups)
// picked up the mutated value — or, via `ifanswerexists`, a different branch
// entirely — and rendered it into an input's `value=`. Submit scrapes the DOM,
// so that reached the payload as an empty string.
//
// Store is no longer a shadow: `Navigation/events.js` builds the
// submit payload from it, so a store write now reaches the server.
// `page_state.form_data` stays read-only for the page anyway, for the render
// reasons above — the template helpers still read it

global.clear_spd_elements_state = function () {
  /**
   * Clear and hide SPD (GDPR) consent content
   */
  $('.spd-consent-text p').text('');
  $('.spd-content').hide();
  if (mainNav) {
    mainNav.skipButton.hide();
  }
};

export function init_page_state(res) {
  if (res.init_state) {
    for (var name in res.init_state) {
      page_state[name] = res.init_state[name];
    }
  }
  // Seed the store with the page's FULL initial answer state, built from the
  // response alone — recorded answers, `passthru`, and the `question.answer`
  // defaults the widgets render but `form_data` never carries. Seeding from
  // `form_data` alone left every server-rendered default invisible to the
  // store; see `answer-seed.js` for why the two channels differ.
  var derived = [];
  var seed = buildInitialAnswers(res, derived);
  answers.reset(seed);
  // The helpers index into this unguarded; a response without `form_data` must
  // not turn every `{{answer}}` into a TypeError.
  page_state.form_data = page_state.form_data || {};
  // Snapshot how many answers existed AT LOAD, which is what
  // `Grid/helpers/displaymax.js` needs for "is this the first question?".
  // Counted from `form_data`, NOT from the seed: the seed deliberately includes
  // defaults and empty placeholders, which are not recorded answers and would
  // make every page look already-answered.
  page_state.initial_answer_count = Object.keys(
    (res.init_state && res.init_state.form_data) || {}
  ).length;
  // `res.variables` is the authoritative list of what this page submits, so it
  // is the completeness oracle for the seed — no DOM read needed. A non-empty
  // result means a widget ships answer state `answer-seed.js` cannot expand yet
  // (grid, rank, cardsort), which now that submit reads from the store instead
  // of the DOM would submit ''.
  page_state.unseeded_variables = unseededVariables(res, seed);
  // The inverse: keys the seeder DERIVED that this page does not submit. A
  // missing key shows up above, a wrong key shows up here — a key-derivation
  // bug produces both at once, which is how the Rule `input_id`/`response_id`
  // mismatch stayed invisible.
  page_state.stray_seeded_variables = strayKeys(res, derived);
  if (
    (page_state.unseeded_variables.length ||
      page_state.stray_seeded_variables.length) &&
    process.env.NODE_ENV !== 'production' &&
    process.env.NODE_ENV !== 'test'
  ) {
    console.warn(
      '[answer-seed] ' +
        page_state.this_page +
        ' — unseeded:',
      page_state.unseeded_variables,
      'stray:',
      page_state.stray_seeded_variables
    );
  }
}

export function clear_page_state() {
  $(window).off('resize.videoPlayer orientationChanged.videoPlayer');
  clear_spd_elements_state();
  $(page_state).unbind();
  page_state = {};
  page_state.vardata = {};
  page_state.page_events = {};
  page_state.initial_answer_count = 0;
  page_state.unseeded_variables = [];
  page_state.stray_seeded_variables = [];
  // Recorded per submit by `Navigation/events.js`; must not carry over.
  page_state.dom_fallback_variables = [];
  page_state.dom_override_variables = [];
  page_state.dom_fallback_errors = [];
  // Clear the store alongside page_state so answers never leak across loads.
  answers.reset({});
}
